<div class="flex gap-2">
  <div class="input-field" *ngFor="let filter of config.filters; let i = index">
    <label for="datasetFieldId">{{filter.datasetFieldLabel}}</label>
    <input [ngModelOptions]="{standalone: true}" type="text" pInputText [(ngModel)]="filter.value"
      *ngIf="(!filter.dropdownOptions || filter.dropdownOptions.length == 0) && filter.dataType !== 'date'  && filter.dataType !== 'datetime' && filter.dataType !=='bool' && filter.dataType !=='number'" />
    <input [ngModelOptions]="{standalone: true}" type="number" pInputText [(ngModel)]="filter.value"
      *ngIf="(!filter.dropdownOptions || filter.dropdownOptions.length == 0) && filter.dataType === 'number'"
      (ngModelChange)="filter.value = '' + $event" />
    <p-dropdown placeholder="Seleccione" [(ngModel)]="filter.value" [options]="arrayYesNo"
      [ngModelOptions]="{ standalone: true }" showClear name="yesNo" appendTo="body" optionLabel="name"
      optionValue="id" *ngIf="filter.dataType === 'bool'" >
    </p-dropdown> 
    
    <p-multiSelect *ngIf="filter.dropdownOptions && filter.dropdownOptions.length > 0"
      [options]="filter.dropdownOptions" optionLabel="Name" optionValue="Id" [(ngModel)]="filter.value"
      [ngModelOptions]="{ standalone: true }" placeholder="Selecciona una o más opciones" appendTo="body"
      (onFilter)="onFilterDropdownOptionsChange(filter.datasetFieldId, $event.filter)"
      showClear>
    </p-multiSelect>
    
    <div class="flex align-items-center gap-2" *ngIf="filter.dataType === 'date' || filter.dataType === 'datetime'">
      <p-dropdown placeholder="Seleccione" [(ngModel)]="filter.value" [options]="arrayDates"
        [ngModelOptions]="{ standalone: true }" showClear name="dates" appendTo="body" optionLabel="name"
        optionValue="id" class="full-width-dropdown">
      </p-dropdown>
      <p-calendar [(ngModel)]="filter.value_data" [ngModelOptions]="{ standalone: true }" [showIcon]="true"
        dateFormat="dd/mm/yy"
        *ngIf="filter.value === 'CUSTOM'">
      </p-calendar>
    </div>
  </div>
  <div class="input-field" *ngIf="config.filters.length > 0">
    <label>&nbsp;</label>
    <p-button label="Mostrar resultados" icon="pi pi-filter" (click)="lastGridEvent.first=0; loadResults()"></p-button>
  </div>
</div>

<p-card *ngIf="report?.description" styleClass="mt-2 report-description">
  <div [innerHTML]="report.description"></div>
</p-card>

  <!--<div class="large-table-fake-top-scroll">
    <div>&nbsp;</div>
  </div>-->
  <p-messages *ngIf="usedSnapshot" severity="info" [closable]="false" styleClass="mt-2">
    <ng-template pTemplate>
      <i class="pi pi-info-circle mr-2"></i>
      Los datos mostrados provienen de un snapshot generado el {{snapshotDate | date:'dd/MM/yyyy HH:mm:ss'}}.
    </ng-template>
  </p-messages>

  <p-table *ngIf="report?.id" styleClass="mt-2" #grid [value]="rows" [lazy]="true" (onLazyLoad)="loadData($event)"
  [lazyLoadOnInit]="false"
    [loading]="loading" [paginator]="true" [rows]="100" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[100,250,1000]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let column of report?.reportConfig?.columns" pSortableColumn="{{column.datasetField?.name}}">
          {{column.label}} <p-sortIcon field="{{column.datasetField?.name}}"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr>
        <td *ngFor="let column of report?.reportConfig?.columns">
          {{getRowValue(row, column)}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="report?.reportConfig?.columns.length">
          <div *ngIf="report?.reportConfig?.columns.length==0">
            <p-messages severity="warn">
              <ng-template pTemplate>
                El informe no tiene configuradas columnas de datos a mostrar.
              </ng-template>
            </p-messages>
          </div>
          <div *ngIf="rows==null || rows.length == 0">
            <p-messages severity="warn">
              <ng-template pTemplate>
                El informe no ha generado resultados.
              </ng-template>
            </p-messages>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-columns>
      <tr *ngIf="hasSumarizedColumns()">
        <td *ngFor="let column of report?.reportConfig?.columns">
          <b *ngIf="column.summarize != null && column.summarize != ''">{{getSummarizedValue(column)}}</b>
        </td>
      </tr>
    </ng-template>
  </p-table>
<p-confirmDialog></p-confirmDialog>